module.exports = __webpack_public_path__ + "img/banner1EN.28d5c2fe.png";